module.exports = __webpack_public_path__ + "static/img/software-card-bg2.png";